import React, { PropTypes } from 'react';
import { NitroParagraph, NitroPanel } from 'nitro-components';

import styled from 'styled-components';

const SummaryCard = styled.div`
  background: ${props => props.theme.color.secondary};
  margin-bottom: 0;
  color: ${props => props.theme.color.white};
  padding: 32px;
  border-radius: ${props => props.card ? 4: 0}px;
  overflow: hidden;
`;

const Cost = styled(NitroParagraph)`
  line-height: 1;
  font-size: 48px;
`;

const Transparency = styled(NitroParagraph)`
  opacity: 0.5;
`;

const QuoteCard = ({ card = true, reference, cost, term }) => {

  return (
    <NitroPanel padding="0" noMargin borderRadius={4}>
      <SummaryCard card={card}>

          {reference &&
            <NitroParagraph variant="primary" size="2" align="center">{`Quote Ref. ${reference}`}</NitroParagraph>}
          {cost && <Cost variant="white" size="48" align="center" noMargin>{`$${cost}`}</Cost>}
          {cost && <Transparency variant="white" size="3" align="center">per month</Transparency>}
          {term && <Transparency variant="white" size="3" align="center" noMargin>{term}</Transparency>}

      </SummaryCard>
    </NitroPanel>
  );
};

QuoteCard.propTypes = {
  card: PropTypes.bool,
  reference: PropTypes.string,
  cost: PropTypes.string,
  term: PropTypes.string
};

export default QuoteCard;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/summary/QuoteCard.js